module.exports = __webpack_public_path__ + "img/fresh_select.376a4ae2.png";